import instance from './AxiosServices';

const PayoutService = {
  getVerificationStatus: () => instance.get('/partners/verification/verification'),
  submitVerification: (data) => instance.post('/partners/verification/verification', data),
  getEarningsSummary: () => instance.get('/partners/settlements/summary'),
  getLedger: (params) => instance.get('/partners/settlements/ledger', { params }),
  getSettlements: (params) => instance.get('/partners/settlements/history', { params }),
};

export default PayoutService;
